import { Box } from "@mui/material";
const COLORS = {
  primary: "#004F45",
  success: "#00D639",
  cardBackground: "#E6F1F1",
  pageBackground: "#F5FAFA",
  iconBackground: "#DDEBEB",
  bodyText: "#666A6B",
  mutedText: "#979797",
  timeline: "#87AAA7",
};
const TimelineIndicator = ({ isLast }) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: { xs: 24, md: 28 },
        flexShrink: 0,
        alignSelf: "stretch",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: { xs: 28, md: 36 },
          width: 10,
          height: 10,
          borderRadius: "50%",
          bgcolor: COLORS.success,
          border: `1px solid ${COLORS.primary}`,
          zIndex: 2,
        }}
      />

      {/* Connector */}
      {!isLast && (
        <Box
          sx={{
            position: "absolute",
            top: { xs: 48, md: 56 },
            bottom: { xs: -40, md: -50 },
            left: "50%",
            transform: "translateX(-50%)",
            borderLeft: `2px dashed ${COLORS.timeline}`,
          }}
        />
      )}
    </Box>
  );
};

export default TimelineIndicator;
